import PropTypes from 'prop-types';
import React from 'react';
import { Flex } from '../grid';

import { P } from '../typography';

const Tabs = ({ options, activeTab, selectTab }) => (
  <>
    {options.map(({ label, value }) => (
      <Flex borderBottom="1px solid" borderColor="grey40" flex="1">
        <Flex
          onClick={() => selectTab(value)}
          key={value}
          borderBottom="4px solid"
          cursor="pointer"
          justifyContent="center"
          flex="1"
          borderColor={activeTab === value ? 'primaryRed' : 'transparent'}
          active={activeTab === value}
        >
          <P variant="standard" fontWeight={activeTab === value ? 600 : 'normal'} mb="8px" pt="11px">
            {label}
          </P>
        </Flex>
      </Flex>
    ))}
  </>
);

Tabs.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
  activeTab: PropTypes.string.isRequired,
  selectTab: PropTypes.func.isRequired,
};

export { Tabs };
